<!-- @format -->

<ng-container *ngIf="validatablePlan">
  <span *ngIf="selectedModule">
    {{ selectedModule.name | localizedString }}
    {{ selectedModule.code ? " - " + selectedModule.code : "" }}
  </span>
  <button type="button" class="link-button" (click)="openPlanSelector()">
    {{ (selectedModule ? "CHANGE" : "PROFILE.APPLICATIONS.SELECT_LOCATION") | translate }}
  </button>
</ng-container>
